import { Link, Stack, H3, Text, ItemCountCircle, FlexRow } from "atoms";
import { constants } from "config";
import { useAuth } from "features/auth";
import { usePendingReviews } from "../api/usePendingReviews";

function ReviewModeration() {
  const { data } = usePendingReviews();
  const {
    user,
    roles: { canModerate },
  } = useAuth();

  // set review count to 0
  let reviewsUntilSeniorCurator = 0;

  // if review count exists and is less than reviewsForSeniorCurator
  if (
    user?.reviewCount &&
    user.reviewCount < constants.reviewsForSeniorCurator
  ) {
    // get count of reviews needed to become a senior curator
    reviewsUntilSeniorCurator =
      constants.reviewsForSeniorCurator - user.reviewCount;
  }

  const reviewsAvailable = data?.notModeratedAvailable ?? 0;
  return (
    <Stack gap="sm">
      <H3 size="sm">Review Moderation</H3>

      {!canModerate && reviewsUntilSeniorCurator ? (
        <Text size="xs">
          Write {reviewsUntilSeniorCurator} more reviews to get promoted to
          Senior Curator and unlock the ability to moderate&nbsp;reviews.
        </Text>
      ) : (
        <>
          {reviewsAvailable ? (
            <>
              <Stack gap="xs">
                <FlexRow justifyContent="center">
                  <ItemCountCircle count={reviewsAvailable} />
                </FlexRow>
                <Text size="xs">reviews awaiting&nbsp;moderation.</Text>
              </Stack>
              <Link to="/moderation" variant="primary" size="xs">
                Moderate Reviews
              </Link>
            </>
          ) : (
            <Stack gap="xs">
              <H3 size="md">We&apos;re all caught up!</H3>
              <Text size="xs">All pending reviews have been moderated</Text>
            </Stack>
          )}
        </>
      )}
    </Stack>
  );
}

export { ReviewModeration };
